/* Uses Dawn's existing option-value lookup; no variant catalogue or IDs are replaced. */
if (!customElements.get('elmuno-gradient-model-guard')) {
  customElements.define('elmuno-gradient-model-guard', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info || this.bound) return;
      this.bound = true;
      this.readyVariantId = null;
      this.currentVariant = null;
      this.requestedModel = null;
      this.onChange = this.handleChange.bind(this);
      this.onSubmit = this.handleSubmit.bind(this);
      this.prepareSelector = this.prepareIncomingSelector.bind(this);
      this.info.addEventListener('change', this.onChange, true);
      this.info.addEventListener('submit', this.onSubmit, true);
      this.info.addPreProcessCallback(this.prepareSelector);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariant.bind(this));
      this.selectModel(this.info, '');
      this.lock(this.dataset.chooseLabel);
    }

    disconnectedCallback() {
      this.info?.removeEventListener('change', this.onChange, true);
      this.info?.removeEventListener('submit', this.onSubmit, true);
      this.unsubscribe?.();
      if (this.info) {
        this.info.preProcessHtmlCallbacks = this.info.preProcessHtmlCallbacks.filter(callback => callback !== this.prepareSelector);
      }
      this.bound = false;
    }

    get select() { return this.info.querySelector('[data-elmuno-model-select]'); }
    get form() { return this.info.querySelector('product-form'); }

    lock(label) {
      this.readyVariantId = null;
      this.currentVariant = null;
      this.form?.toggleSubmitButton(true, label);
      this.info.dispatchEvent(new CustomEvent('elmuno:gradient-model-change'));
    }

    refreshSubmit() {
      if (!this.readyVariantId) return;
      const personalizer = this.info.querySelector('elmuno-gradient-personalizer');
      const blocked = personalizer?.blocksSubmit === true;
      this.form?.toggleSubmitButton(blocked, blocked ? personalizer.submitLabel : undefined);
    }

    selectModel(root, model) {
      const select = root.querySelector('[data-elmuno-model-select]');
      if (!select) return false;
      const selected = Array.from(select.options).find(option => option.value === model);
      if (!selected) return false;
      // Dawn reads the selected attribute, not only the DOM selected property.
      Array.from(select.options).forEach(option => {
        option.removeAttribute('selected');
        option.selected = false;
      });
      selected.selected = true;
      selected.setAttribute('selected', 'selected');
      return true;
    }

    handleChange(event) {
      if (!event.target.matches('[data-elmuno-model-select]')) return;
      this.requestedModel = event.target.value || null;
      this.lock(this.requestedModel ? this.dataset.loadingLabel : this.dataset.chooseLabel);
    }

    prepareIncomingSelector(node) {
      if (!this.requestedModel) return;
      const json = node.querySelector('variant-selects [data-selected-variant], [data-selected-variant]');
      const variant = json ? JSON.parse(json.textContent) : null;
      if (variant?.options?.[0] === this.requestedModel) {
        this.selectModel(node, this.requestedModel);
      }
    }

    handleVariant({ data: { sectionId, html, variant } }) {
      if (String(sectionId) !== this.info.dataset.section || !this.requestedModel) return;
      const sourceButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
      const input = this.form?.querySelector('input[name="id"]');
      const matches = variant && variant.options?.[0] === this.requestedModel &&
        this.select?.value === this.requestedModel && String(input?.value) === String(variant.id);
      if (!matches) {
        this.lock(this.dataset.chooseLabel);
        return;
      }
      const available = variant.available && sourceButton?.dataset.elmunoVariantUnavailable === 'false';
      this.readyVariantId = available ? String(variant.id) : null;
      this.currentVariant = available ? variant : null;
      this.form.toggleSubmitButton(!available, window.variantStrings.soldOut);
      this.info.dispatchEvent(new CustomEvent('elmuno:gradient-model-change'));
      this.refreshSubmit();
    }

    handleSubmit(event) {
      if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
      const input = event.target.querySelector('input[name="id"]');
      if (this.readyVariantId && String(input?.value) === this.readyVariantId &&
          this.select?.value === this.requestedModel) {
        const personalizer = this.info.querySelector('elmuno-gradient-personalizer');
        if (!personalizer?.blocksSubmit) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.refreshSubmit();
        personalizer.querySelector('[data-egp-name]')?.focus();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.lock(this.dataset.chooseLabel);
      this.select?.focus();
    }
  });
}
